export const locale = {
  searchSymbol: 'Symbol search',
  compareSymbol: 'Compare Symbol',
  apply: 'Apply',
  firstPoint: 'Point 1',
  secondPoint: 'Point 2'
};
